import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

// Packages
import { Button, Col, Divider, Flex, Row, Typography } from 'antd';
import PropTypes from 'prop-types';

// Components
import OrgFilters from '../filters/OrgFilters';
import AreaFilters from '../filters/AreaFilters';
import FileForm from './FileForm';
import FilesTable from './FilesTable';

// Actions
import { get_all_files } from '../../actions/filesActions';

const Files = (props) => {
	const { messageApi } = props;

	const dispatch = useDispatch();

	const { isAdminUser } = useSelector(state => state.auth);

	const { user_staff } = useSelector(state => state.staffs);

	const { global_data } = useSelector(state => state.global);

	const [orgFilters, setOrgFilters] = useState({ organization: '', workspace: '' });
	const [areaFilters, setAreaFilters] = useState({ region: '', zone: '' });
	const [isModalOpen, setIsModalOpen] = useState(false);
	const [update, setUpdate] = useState(false);
	const [fileToUpdate, setFileToUpdate] = useState({});
	const [pageSize, setPageSize] = useState(10);
	const [skip, setSkip] = useState(0);

	useEffect(() => {
		if (orgFilters.organization !== '') {
			const filters = {
				...orgFilters,
				...areaFilters,
				skip: skip,
				limit: pageSize
			};
			dispatch(get_all_files(filters));
		}
	}, [orgFilters, areaFilters]);

	const handleAdd = () => {
		setIsModalOpen(true);
		setUpdate(false);
		setFileToUpdate({});
	}

	return (
		<div>
			<FileForm
				messageApi={messageApi}
				orgFilters={orgFilters}
				areaFilters={areaFilters}
				isModalOpen={isModalOpen}
				setIsModalOpen={setIsModalOpen}
				update={update}
				fileToUpdate={fileToUpdate}
				setFileToUpdate={setFileToUpdate}
				pageSize={pageSize}
				skip={skip}
				setSkip={setSkip}
			/>

			<Row style={{ marginBottom: '1rem' }}>
				<Col xs={24} sm={18} md={18} lg={18} xl={18}>
					<Typography.Title>{global_data?.files?.title}</Typography.Title>
					<Typography.Text>{global_data?.files?.description}</Typography.Text>
				</Col>
				{(isAdminUser || user_staff?.staff_type === 1) && (
					<Col xs={24} sm={6} md={6} lg={6} xl={6}>
						<Flex align='center' justify='flex-end' style={{ height: '100%' }}>
							<Button
								type='primary'
								size='large'
								onClick={handleAdd}
							>
								{global_data?.actionButtons?.create}
							</Button>
						</Flex>
					</Col>
				)}
			</Row>

			<OrgFilters
				orgFilters={orgFilters}
				setOrgFilters={setOrgFilters}
				displayFilters={{ organization: true, workspace: true }}
			/>

			<Divider />

			<Typography style={{ textAlign: 'center' }}><i className='bi bi-globe2' style={{ marginRight: '0.5rem' }}></i>{global_data?.organizationTerms?.areas}</Typography>
			<AreaFilters
				orgFilters={orgFilters}
				areaFilters={areaFilters}
				setAreaFilters={setAreaFilters}
			/>

			<Divider />
			
			<FilesTable
				messageApi={messageApi}
				orgFilters={orgFilters}
				areaFilters={areaFilters}
				setIsModalOpen={setIsModalOpen}
				setUpdate={setUpdate}
				setFileToUpdate={setFileToUpdate}
				pageSize={pageSize}
				skip={skip}
				setSkip={setSkip}
			/>
		</div>
	)
}

Files.propTypes = {
	messageApi: PropTypes.object.isRequired
}

export default Files;
